import { Injectable } from '@angular/core';
import { LabTestDataModel } from '../../../models/master-data/lab-test-data.model';
import { BaseService } from '../../../shared/services/base.service';
import { LabTestUrl } from '../../../shared/urls/master-data.labtest.url';
import { LabTestCategoryUrl } from '../../../shared/urls/master-data.labtest-category.url';

@Injectable()
export class LabTestDataService {
    constructor(public baseService : BaseService) {
    }

    getLabTestById(id) {
        const url = LabTestUrl.LABTEST_DETAIL + `${id}`;
        return this.baseService.getById(url, id);
    }
    getLabTestCategory(){
        const url = LabTestCategoryUrl.LABTESTCATEGORY_GET_DROP_DOWN_LIST;
        return this.baseService.getData(url);
    }
    getLabTestBycategory(param){
        const url = LabTestUrl.LABTEST_GET;
        return this.baseService.getData(url, param);
    }

    removeLabTest(id){
        const url = LabTestUrl.LABTEST_DELETE.replace('{id}',id);
        return this.baseService.delete(url);
    }

    updateLabTest(id, param){
        const url = LabTestUrl.LABTEST_UPDATE + `${id}`;
        return this.baseService.put(url, param);
    }

    getScreenData(){
        const url = LabTestUrl.LABTEST_GET_SCREENTYPE;
        return this.baseService.getData(url);
    }

    getLabtestTestResult(){
        const url = LabTestUrl.LABTEST_GET_LABTEST_TESTRESULT;
        return this.baseService.getData(url);
    }

    getLabtestTypeData(){
        const url = LabTestUrl.LABTEST_GET_LABTESTTYPE;
        return this.baseService.getData(url);
    }

    addNewLabTest(param){
        const url = LabTestUrl.LABTEST_ADD;
        return this.baseService.postData(url, param);
    }
}



// WEBPACK FOOTER //
// D:/TMB/sr-git-v1/TMB.UI/src/app/pages/master-data/lab-test-data/lab-test-data.service.ts